/* global variables */

import XHR from './xhr';

class Ratsit {
    constructor(options) {
        // if (!this.validate(options.pnr)) {
        //     return false;
        // }

        this.pnr = options.pnr;
        this.pack = options.pack;
        this.callbackId = options.callbackId;

        return this;
    }

    fetch() {
        var data = {
            action : variables.ratsitFetch,
            nonce : variables.nonce,
            pnr : this.pnr,
            pack : this.pack,
        }

        var xhr = new XHR({
            'url' : variables.ajax_url,
            'data' : data,
        });

        xhr.send(this.successCallback, this.errorCallback, this.callbackId);
    }

    successCallback(response, callbackId) {
        var event = new CustomEvent('ratsitsuccess', {
            'detail' : {
                'response' : response,
                'callbackId' : callbackId,
            },
        });
        document.dispatchEvent(event);
    }

    errorCallback(response) {
        console.log('ErrorCallback', response);
    }

    getData() {
        return this.data;
    }

}
export default Ratsit;



// WEBPACK FOOTER //
// ./scripts/lib/ratsit.js